import React from "react";
import MainContainer from "../../components/container/MainContainer";

const ManageSingleProject = () => {
  return <MainContainer>ManageSingleProject</MainContainer>;
};

export default ManageSingleProject;
